module.exports = __webpack_public_path__ + "img/DE.da89e224.svg";